import { useSearch } from "@tanstack/react-router";
import { useContext, useState } from "react";
import { StartFlowResponse } from "src/services/link/commands/NetTypes";
import {
	useStartFlowRequest,
	useStartUpdateFlowRequest
} from "src/services/link/commands/start-flow";
import { decodeAccessToken } from "src/utils/jwt";

import { ConnectAccountParams } from "../ConnectAccount/ConnectAccount";
import ThemeContext from "../context";

export const useMutateStartFlow = () => {
	const [isLoading, setIsLoading] = useState(true);
	const { actions, id, state, product, subproduct } = useContext(ThemeContext);
	const { updateToken, restoreToken, authToken }: ConnectAccountParams = useSearch({
		strict: false
	});

	const startReq = useStartFlowRequest();
	const updateReq = useStartUpdateFlowRequest();

	const onSuccess = (response: StartFlowResponse) => {
		const { redirectUri, maintenance } = decodeAccessToken(response.authToken);
		console.log(maintenance);
		actions.onStartFlow({ ...response, redirectUri, maintenance });
		setTimeout(() => {
			setIsLoading(false);
		}, 1000);
	};

	const onError = ({ response }: any) => {
		if (
			response.data?.message === "product_not_contracted" ||
			response.data?.message === "invalid_product_subproduct_combination" ||
			response.data?.message === "product_not_supported_for_entity"
		)
			actions.onProductError();
		else if (response.data?.message === "update_in_process")
			actions.onErrorMessage("update_in_process");
		else if (response.data?.message === "secure_connection_required")
			actions.onErrorMessage("secure_connection_required");
		else if (response.data?.message === "token_not_found")
			actions.onErrorMessage("token_not_found");
		setTimeout(() => {
			setIsLoading(false);
		}, 1000);
	};

	const startFlow = (exId?: string) => {
		setIsLoading(true);

		if (authToken && authToken !== "") {
			const { redirectUri, maintenance } = decodeAccessToken(authToken);
			onSuccess({
				authToken: authToken,
				maintenance: maintenance,
				redirectUri: redirectUri
			});
			setIsLoading(false);
			return;
		} else {
			const externalId = exId ? { externalId: exId } : {};
			const subProduct = subproduct ? { subproduct } : {};
			startReq.mutate(
				{
					entity: state.entity?.id,
					id,
					product: product ?? "TRANSACTIONS",
					...subProduct,
					...externalId
				},
				{ onSuccess, onError }
			);
		}
	};

	const startUpdateFlow = () => {
		updateReq.mutate(
			{
				id,
				token: updateToken ?? restoreToken
			},
			{ onSuccess, onError }
		);
	};

	return { startFlow, startUpdateFlow, isLoading };
};
